export default __webpack_public_path__ + "static/media/about-graphic.fee89298.svg";